const USER_TYPES = Object.freeze({
	PRACTICE: { name: 'Practice', value: 1 },
	LOCUM: { name: 'Locum', value: 2 },
});

export class User {
	constructor() {}

	static get TYPES() {
		return USER_TYPES;
	}

	static get TYPE_VALUES() {
		return Object.values(this.TYPES);
	}

	static getTypeName(type) {
		if (!type) return undefined;
		return this.TYPE_VALUES.find(x => x.value === type);
	}
}
